import type { ThemePreset } from './types';

function camelToKebab(value: string) {
  return value.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
}

export function themeToCssVars(preset: ThemePreset): Record<string, string> {
  const vars: Record<string, string> = {};

  for (const [key, value] of Object.entries(preset.colors)) {
    vars[`--${camelToKebab(key)}`] = value;
  }

  vars['--radius'] = preset.radius.base;
  vars['--border-width'] = preset.border.width;

  for (const [key, value] of Object.entries(preset.typography.fontSize)) {
    vars[`--font-size-${key}`] = value;
  }

  for (const [key, value] of Object.entries(preset.typography.lineHeight)) {
    vars[`--line-height-${key}`] = value;
  }

  for (const [key, value] of Object.entries(preset.typography.fontWeight)) {
    vars[`--font-weight-${key}`] = value;
  }

  vars['--shadow-notion'] = preset.shadow.notion;
  vars['--shadow-notion-lg'] = preset.shadow.notionLg;
  vars['--shadow-toast'] = preset.shadow.toast;

  vars['--ring-width'] = preset.ring.width;
  vars['--ring-offset'] = preset.ring.offset;

  vars['--transition-fast'] = preset.transition.duration.fast;
  vars['--transition-normal'] = preset.transition.duration.normal;
  vars['--transition-slow'] = preset.transition.duration.slow;

  vars['--scrollbar-width'] = preset.scrollbar.width;
  vars['--scrollbar-thumb-radius'] = preset.scrollbar.thumbRadius;

  vars['--layout-sidebar-width'] = preset.layout.sidebarWidth;
  vars['--layout-header-height'] = preset.layout.headerHeight;
  vars['--layout-mobile-header-height'] = preset.layout.mobileHeaderHeight;
  vars['--layout-content-padding'] = preset.layout.contentPadding;
  vars['--layout-mobile-content-padding'] = preset.layout.mobileContentPadding;

  return vars;
}
